SupportUtilsHelper = require('../helpers/utils')

class SupportOrdersFilterConditionsModel

  sortPurchasedDateAscendingFn: (a,b) ->
    a = getMillisecondsOfUTCDateFromISOStringDate a.purchasedAt
    b = getMillisecondsOfUTCDateFromISOStringDate b.purchasedAt
    @sortAscendingFunction(a,b)

  sortPurchasedDateDescendingFn: (a,b) ->
    a = getMillisecondsOfUTCDateFromISOStringDate a.purchasedAt
    b = getMillisecondsOfUTCDateFromISOStringDate b.purchasedAt
    @sortDescendingFunction(a,b)

  sortMerchantNameAscendingFn: (a,b) ->
    a = @getBusinessName a
    b = @getBusinessName b
    @sortAscendingFunction(a,b)

  sortMerchantNameDescendingFn: (a,b) ->
    a = @getBusinessName a
    b = @getBusinessName b
    @sortDescendingFunction(a,b)

  sortExpiredDateAscendingFn: (a,b) ->
    a = @parseAndAssignMaxValueIfDateIsNull a
    b = @parseAndAssignMaxValueIfDateIsNull b
    @sortAscendingFunction(a,b)

  sortExpiredDateDescendingFn: (a,b) ->
    a = @parseAndAssignMaxValueIfDateIsNull a
    b = @parseAndAssignMaxValueIfDateIsNull b
    @sortDescendingFunction(a,b)

  getBusinessName: (order) ->
    name = switch order.DEAL_TYPE
      when 'GETAWAYS_MARKET_RATE'
        reservationSource = SupportUtilsHelper.getReservationSource(order)
        reservationSource?.hotelName
      else order.merchant?.name
    name?.toUpperCase()

  parseAndAssignMaxValueIfDateIsNull: (a) ->
    if a.groupons[0].expiresAt == null
      a = Number.MAX_VALUE
    else
      a = getMillisecondsOfUTCDateFromISOStringDate a.groupons[0].expiresAt

  sortDescendingFunction: (a,b) ->
    if(a < b)
      return 1
    if(b < a)
      return -1
    return 0

  sortAscendingFunction: (a,b) ->
    if (a < b)
      return -1
    if (b < a)
      return 1
    return 0

module.exports = SupportOrdersFilterConditionsModel
